import { useQuery } from '@tanstack/react-query'
import { TFunction } from 'i18next'
import { getInformationService } from 'shared/services/informationModalService'

export const useInformationModalService = (t: TFunction) => {
	return useQuery(['informationService'], () => getInformationService(t), {
		staleTime: Infinity,
		cacheTime: Infinity,
		refetchOnWindowFocus: false,
	})
}
